import { render, staticRenderFns } from "./Negocios.vue?vue&type=template&id=8c369d4a&"
import script from "./Negocios.vue?vue&type=script&lang=js&"
export * from "./Negocios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports